import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_PRODUCT_LIST: string = typeCreatorV2(
  'ReportingReducer',
  'SetProductList'
);

export const SET_CATEGORY: string = typeCreatorV2(
  'ReportingReducer',
  'SetCategory'
);

export const SET_PUBLISHED: string = typeCreatorV2(
  'ReportingReducer',
  'SetPublished'
);

export const SET_FILTERS_SELECTION: string = typeCreatorV2(
  'ReportingReducer',
  'SetFiltersSelection'
);

export const INSERT_PRODUCT_FILTER: string = typeCreatorV2(
  'ReportingReducer',
  'InsertProductFilter'
);

export const SAVE_SEARCH: string = typeCreatorV2(
  'ReportingReducer',
  'SaveSearch'
);
